import {LinkTypeEnum} from './link-type.enum';

export class Link {
  link: string;
  typeLink: LinkTypeEnum;

  constructor(link, typeLink) {
    this.link = link;
    this.typeLink = typeLink;
  }
}
